export default __webpack_public_path__ + "static/media/media-residential-1.bede7562.jpg";